export default "__VITE_ASSET__wA9oAvLo__"